import { GrupoProcedimentoEnum } from 'graphql/types.generated'

export const QTD_PROCEDIMENTOS_MIN = 1
export const QTD_PROCEDIMENTOS_MAX = 20
export const MSG_ERRO_PROCEDIMENTOS_MIN =
  'É necessário registrar pelo menos um procedimento, no Plano ou na Finalização do atendimento.'
export const MSG_ERRO_PROCEDIMENTOS_MAX = `O número máximo de procedimentos em um atendimento é ${QTD_PROCEDIMENTOS_MAX}.`

export const GRUPOS_PROCEDIMENTOS_PADRAO = [
  GrupoProcedimentoEnum.ACOES_PROMOCAO_PREVENCAO_SAUDE,
  GrupoProcedimentoEnum.FINALIDADE_DIAGNOSTICA,
  GrupoProcedimentoEnum.CLINICOS,
  GrupoProcedimentoEnum.CIRURGICO,
  GrupoProcedimentoEnum.ACOES_COMPLEMENTARES_ATENCAO_SAUDE,
]
